import React from 'react'
import has from 'lodash/has'
import upperFirst from 'lodash/upperFirst'
import isArray from 'lodash/isArray'

import NotFound from '../Pages/NotFound'

import ManageDestination from './Destination/ManageDestination'
import Mapping from './Destination/Mapping'

const subList = {
  Manage: <ManageDestination/>,
  Mapping: <Mapping/>
}

const SubComponent = ({subname = 'manage', location}) => {
  let index = subname
  index = index.split('-')
  if (!isArray(index)) {
    index = upperFirst(index)
  } else {
    index = index.map((el) => upperFirst(el))
    index = index.join('')
  }

  if (has(subList, index)) {
    return subList[index]
  } else {
    return <NotFound/>
  }
}

const UserPage = ({location, match}) => <SubComponent subname={match.params.sub} location={location}/>

export default UserPage



// WEBPACK FOOTER //
// ./src/Pages/DestinationPage.js